import axios from 'axios'

export function rawAxiosGet(url, headers) {
	var instance = axios.create()
	// instance.defaults.headers.common = {}
	// instance.defaults.headers = {}

	return axios({
		method: 'GET',
		url: url,
		withCredentials: false,
		headers: {
			...headers
		},
		transformRequest: (data, headers) => {
			delete headers['Authorization']
			delete headers.common['Authorization']
			delete headers['Pragma']
			delete headers.common['Pragma']
			return data
		}
	})
		.then(result => {
			return result
		})
		.catch(err => {
			return err
		})
}
